export const QUERY_KEY = {
  getParticularExamHybrid: "getparticularexam/hybrid",
};
